import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
	{
		path: '/Login',
		name: 'Login',
		component:() => import('../views/login/Login')
	},
	{
		path: "/",
		name: "Index",
		component: () => import("../views/Main"),
		meta: {
			title: '主页'
		},
		children: [
			{
				path: "/",
				name: "Index",
				component: () => import("../views/Index"),
			},
			{
				path: "/type",
				name: "typeManage",
				component: () => import("../views/baseManage/TypeManage"),
				meta: {
					title: '版本'
				},
			},
			{
				path: "/word/type",
				name: "wordType",
				component: () => import("../views/baseManage/WordType"),
				meta: {
					title: '词类管理'
				},
			},
            {
                path: "/base/type/tree",
                name: "baseTypeTree",
                component: () => import("../views/baseManage/BaseTypeTree"),
                meta: {
                    title: '基础版本目录'
                },
            },
            {
                path: "/question",
                name: "questionList",
                component: () => import("../views/baseManage/QuestionList"),
                meta: {
                    title: '题目列表'
                },
            },
            {
                path: "/work",
                name: "workList",
                component: () => import("../views/baseManage/WordList"),
                meta: {
                    title: '单词'
                },
            },
            {
                path: "/synchronize/word/book/",
                name: "synchronizeWordBook",
                component: () => import("../views/wordBook/WordBook"),
                meta: {
                    title: '同步单词本'
                },
            },
            {
                path: "/frequently/word/book/",
                name: "frequentlyWordBook",
                component: () => import("../views/wordBook/WordBook"),
                meta: {
                    title: '高频单词本'
                },
            },
            {
                path: "/word/book/catalog",
                name: "wordBookCatalog",
                component: () => import("../views/wordBook/WordBookCatalog"),
                meta: {
                    title: '单词本目录'
                },
            },
			{
				path: "/workbook",
				name: "workBookManage",
				component: () => import("../views/baseManage/RouterView"),
				meta: {
					title: '单词本'
				},
				children : [
					{
						path: "/workbook",
						name: "workBookManage",
						component: () => import("../views/wordBook/WordBook"),
					},
					{
						path: "/workbook/module",
						name: "wordBookModule",
						component: () => import("../views/wordBook/WordBookCatalog"),
						meta: {
							title: '单词'
						},
					},

                    {
                        path: "/workbook/group/upload",
                        name: "moduleUploadQuestion",
                        component: () => import("../views/baseManage/UploadGroupQuestion"),
                        meta: {
                            title: '上传题目'
                        },
                    },


				]
			},
			{
				path: "/article/book",
				name: "articleManage",
				component: () => import("../views/baseManage/RouterView"),
				meta: {
					title: '文章'
				},
                children : [
                    {
                        path: "/article/book",
                        name: "articleManage",
                        component: () => import("../views/articleBook/ArticleBookManage"),
                    },
                    {
                        path: "/article/module",
                        name: "articleBookModule",
                        component: () => import("../views/articleBook/ArticleBookModule"),
                        meta: {
                            title: '模块'
                        },
                    },
                    {
                        path: "/article/list",
                        name: "articleList",
                        component: () => import("../views/articleBook/ArticleList"),
                        meta: {
                            title: '文章'
                        },
                    },


                ]

			},
            {
                path: "/user",
                name: "userManage",
                component: () => import("../views/baseManage/RouterView"),
                meta: {
                    title: '单词本'
                },
                children : [
                    {
                        path: "/user",
                        name: "userManage",
                        component: () => import("../views/user/User"),
                    },
                    {
                        path: "/user/word/book",
                        name: "userWordBook",
                        component: () => import("../views/user/UserWordBook"),
                    },
                    {
                        path: "/user/word/lists",
                        name: "userStrangeErrorWord",
                        component: () => import("../views/user/UserStrangeErrorWord"),
                    },
                    {
                        path: "/user/exam/lists",
                        name: "userExamLists",
                        component: () => import("../views/user/UserExamLists"),
                    },
                    {
                        path: "/user/exam/analysis",
                        name: "userExamAnalysis",
                        component: () => import("../views/user/userExamAnalysis"),
                    },
                ]
            },
		]
	},
	{ path: "*", redirect: { name: "/" } } // 重定向到主页
]

const router = new VueRouter({routes})

export default router



// WEBPACK FOOTER //
// ./src/config/router.js